import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ca-memo-relates-to-selector',
    styleUrls: ['./memo-relates-to-selector.component.scss'],
    templateUrl: 'memo-relates-to-selector.component.html',
    standalone: false
})
export class MemoRelatesToSelectorComponent {
  _selected = [];
  @Output() values = new EventEmitter<string[]>();
  @Input() categories;
  @Input() loading;
  @Input()
  set selected(data) {
    if (!data) { return; }
    this._selected = data;
  }

  updateValue(id) {
    let values = [...this._selected];
    if (values.includes(id)) {
      values = values.filter(item => item !== id);
    } else {
      values = [...values, id];
    }
    this._selected = values;
    this.values.emit(this._selected);
  }

  changeSelection(list: any[]) {
    return (this._selected = list);
  }

  toggle(categoryId: string): void {
    const index = this._selected.indexOf(categoryId);

    if (index >= 0) {
      this._selected = this._selected.filter((item) => item !== categoryId);
    } else {
      this._selected = [...this._selected, categoryId];
    }
    this.values.emit(this._selected);
  }
}
